import styled from 'styled-components'

export const AppContainer = styled.div`
    width: 100vw;
    min-height: 100vh;
    height: 100%;
    background: var(--background);
    transition: 0.2s;
`